import {
  HOME_CARE_SOLUTIONS,
  MEDICAL_SUPPLIES_SOLUTIONS,
  SOLUTION_FULL_TIME_MOBILE_CARE,
  SOLUTION_HELP_AT_HOME,
  SOLUTION_MOBILE_CARE,
} from "core/consts";
import { shouldRedactHouseNumber } from "core/model/auctions";
import { preprocessZipcode, validateZipcode } from "core/model/utils/location";
import { SearchType, Solutions } from "core/types";
import {
  convertModelDefinition,
  encryptedDef,
  required,
} from "react-forms-state";

const HOUSE_NUMBER_SOLUTIONS = [
  SOLUTION_MOBILE_CARE,
  SOLUTION_HELP_AT_HOME,
  SOLUTION_FULL_TIME_MOBILE_CARE,
  ...MEDICAL_SUPPLIES_SOLUTIONS,
  ...HOME_CARE_SOLUTIONS,
] as Solutions;

export function requiredHouseNumber({
  search_type,
  share_patient_data_automatically,
  solutions,
}: {
  search_type: SearchType;
  share_patient_data_automatically: boolean | undefined;
  solutions?: Solutions;
}): boolean {
  if (
    shouldRedactHouseNumber({
      search_type,
      share_patient_data_automatically,
    })
  ) {
    return true;
  }

  if (!solutions) {
    return false;
  }
  return !solutions.every((s) => HOUSE_NUMBER_SOLUTIONS.indexOf(s) < 0);
}

export const getModelDefinition = (
  country: any,
  encryptionActivated: boolean,
) =>
  convertModelDefinition({
    city: {
      default: null,
      out: "city",
      validate: required(),
    },
    floor: {
      convertOut: (value: any) => value?.trim() || null,
      default: null,
      out: "floor",
    },
    house_number: {
      default: null,
      out: "house_number",
      validate: (value: any, props: any) =>
        requiredHouseNumber({
          search_type: props.search_type,
          share_patient_data_automatically:
            props.share_patient_data_automatically,
          solutions: props.solutions,
        }) && encryptionActivated
          ? required()(value)
          : true,
    },
    street: {
      convertOut: (value: any) => value.trim(),
      default: null,
      out: "street",
      validate: required(),
    },
    ...encryptedDef("encrypted_house_number"),
    country: {
      convertOut: () => country,
      default: null,
      out: "country",
    },
    zipcode: {
      // @ts-expect-error
      convertOut: preprocessZipcode(),
      default: null,
      out: "zipcode",
      validate: validateZipcode(true),
    },
  });
